import { PdfExportService } from './../../services/pdf-export.service';
import { Component } from '@angular/core';
import { MapComponent } from 'src/app/components/map/map.component';
import { AnyHandler, FullScreenElement, SLVApp } from 'src/app/types/@types/sl-v-types';
import { ViewStackComponent } from 'src/app/components/view-stack/view-stack.component';
import { ViewStackViewComponent } from 'src/app/components/view-stack/view-stack-view/view-stack-view.component';
import { SLContext } from 'src/app/types/sl-context';
import { ActionMap } from 'src/app/services/action-handler.service';
import { SLViewerComponent } from 'src/app/mapps/sl-viewer/sl-viewer.component';
import { ButtonGroupService } from 'src/app/services/button-group.service';
import { DrawPaneComponent } from 'src/app/components/draw-pane/draw-pane.component';
import { MapService } from 'src/app/services/map.service';
import { getList, getNumber, getBool } from 'src/app/model/param-utils';

export type OpacityTogglePayload = {
  layers: string[] | string;
  opacity: number | string;
};

export type ToggleVisibilityPayload = {
  visibility_map: Record<string, number>;
};
export class DisplayAction {
  private static app: SLVApp;
  public static SetApp(app) {
    DisplayAction.app = app;
  }
  public static Exec(command: string, map: MapComponent, data: any) {
    switch (command) {
      case 'basemap-streets':
        DisplayAction.SetStreetsBaseMap(map, data);
        break;
      case 'basemap-light':
        DisplayAction.SetLightBaseMap(map, data);
        break;
      case 'basemap-dark':
        DisplayAction.SetDarkBaseMap(map, data);
        break;
      case 'basemap-outdoors':
        DisplayAction.SetOutdoorBaseMap(map, data);
        break;
      case 'basemap-streets':
        DisplayAction.SetStreetsBaseMap(map, data);
        break;
      case 'basemap-satellite':
        DisplayAction.SetsatelliteBaseMap(map, data);
        break;
      case 'basemap-hillshade':
        DisplayAction.ToggleHillshade(map, data);
        break;
      case 'basemap-contours':
        DisplayAction.ToggleContour(map, data);
        break;
      case 'basemap-buildings':
        DisplayAction.ToggleBuildings(map, data);
        break;
      case 'terrain':
        DisplayAction.ToggleTerrain(map, data);
        break;
      case 'full-screen':
        // DisplayAction.FullScreen(map);
        break;
      case 'full-screen-exit':
        DisplayAction.ExitFullScreen(map, data);
        break;
      case 'toggle-bars':
        DisplayAction.ToggleBars(map, data);

        break;
      case 'save':
        map.SLMap.SavePrompt(() => {

        });
        break;
      case 'load':
        map.SLMap.LoadPrompt(() => {

        });
        break;
      case 'logout':
        map.SLMap.messager.Confirm('This will log you out of your current session, click Ok to log out or cancel to continue your current session.', () => {
          if (!!map.SLMap?.src?.Logout) {
            map.SLMap.src.Logout()
          }
        }, () => { }, 'Log out confirmation');
      default:
        const funcName = command
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join('');

        const actionFunc = (DisplayAction as any)[funcName];

        if (typeof actionFunc === 'function') {
          actionFunc(map, data);
        } else {
          console.warn(`DisplayAction.${funcName} not found for command '${command}'`);
        }
        break;
    }
  }
  public static RegisterActions(actions): ActionMap {
    actions['display/toggle-panel-primary'] = {
      name: 'Toggle primary panel',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.TogglePrimaryPanel(context);
      },
      keys: {
        key: '1',
      },
      trigger: 'press'
    }
    actions['display/toggle-panel-secondary'] = {
      name: 'Toggle secondary panel',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleSecondaryPanel(context);
      },
      keys: {
        key: '2',
      },
      trigger: 'press'
    }
    actions['display/toggle-panel-extended'] = {
      name: 'Toggle extended panel',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleExtendedPanel(context);
      },
      keys: {
        key: '3',
      },
      trigger: 'press'
    }
    actions['display/basemap-streets'] = {
      name: 'Toggle Streets background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.SetStreetsBaseMap(context.map.component, _args);
      }
    }
    actions['display/basemap-dark'] = {
      name: 'Toggle Dark background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.SetDarkBaseMap(context.map.component, _args);
      }
    }
    actions['display/basemap-light'] = {
      name: 'Toggle Light background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.SetLightBaseMap(context.map.component, _args);
      }
    }
    actions['display/basemap-outdoors'] = {
      name: 'Toggle Outdoords background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.SetOutdoorBaseMap(context.map.component, _args);
      }
    }
    actions['display/basemap-satellite'] = {
      name: 'Toggle Satellite background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.SetsatelliteBaseMap(context.map.component, _args);
      }
    }
    actions['display/basemap-hillshade'] = {
      name: 'Toggle Hillshade background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleHillshade(context.map.component, _args);
      }
    }
    actions['display/basemap-contours'] = {
      name: 'Toggle Countours background map display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleContour(context.map.component, _args);
      }
    }
    actions['display/basemap-buildings'] = {
      name: 'Toggle buildings display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleBuildings(context.map.component, _args);
      }
    }
    actions['display/terrain'] = {
      name: 'Toggle 3D Terrain display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleTerrain(context.map.component, _args);
      }
    }
    actions['display/full-screen'] = {
      name: 'Show viewer in full screen',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.FullScreen(context.map.component, _args);
      }
    }
    actions['display/full-screen-exit'] = {
      name: 'Exit full screen viewer',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ExitFullScreen(context.map.component, _args);
      }
    }

    actions['display/toggle-bars'] = {
      name: 'Toggle header and footer display',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.ToggleBars(context.map.component, _args);
      }
    }
    actions['display/load'] = {
      name: 'Reload map content...',
      handler: (context: SLContext, ..._args: any) => {
        context.map.LoadPrompt(() => {

        });
      }
    }
    actions['display/export-pdf'] = {
      name: 'Export A PDF Document...',
      handler: (context: SLContext, ..._args: any) => {
        context.GetPdfOutputSvc().Show(() => { }, context);
      }
    }
    actions['display/save'] = {
      name: 'Save map content...',
      handler: (context: SLContext, ..._args: any) => {
        context.map.SavePrompt(() => {

        });
      }
    }
    actions['display/logout'] = {
      name: 'Log out...',
      handler: (context: SLContext, ..._args: any) => {
        DisplayAction.Exec('logout', context.map.component, {})
      }
    }

    return actions;

  }
  static TogglePrimaryPanel(context: SLContext) {
    (context as SLViewerComponent).panelSet.TogglePrimary();
  }
  static ToggleSecondaryPanel(context: SLContext) {
    (context as SLViewerComponent).panelSet.ToggleSecondary();
  }
  static ToggleExtendedPanel(context: SLContext) {
    (context as SLViewerComponent).panelSet.ToggleExtended();

  }
  static SetPrimaryView(viewName: string): Component | null {
    if (!DisplayAction.app) {
      return;
    }
    const app = DisplayAction.app as SLVApp & { buttonGroups?: ButtonGroupService };
    if (app.buttonGroups) {
      app.buttonGroups.CloseAll();
    }
    if (!!DisplayAction.app.primaryViews) {
      DisplayAction.app.primaryViews.SetView(viewName);
      return DisplayAction.app.GetViewComponent(DisplayAction.app.primaryViews.currentView);
    }
  }
  static SetSecondaryView(viewName: string): Component | null {
    if (!DisplayAction.app) {
      return;
    }
    if (!!DisplayAction.app.secondaryViews) {
      DisplayAction.app.secondaryViews.SetView(viewName);
      return DisplayAction.app.GetViewComponent(DisplayAction.app.secondaryViews.currentView);
    }
  }
  static SetExtendedView(viewName: string): Component | null {
    if (!DisplayAction.app) {
      return;
    }
    if (!!DisplayAction.app.extendedViews) {
      DisplayAction.app.extendedViews.SetView(viewName);
      return DisplayAction.app.GetViewComponent(DisplayAction.app.extendedViews.currentView);
    }
  }
  static SetStreetsBaseMap(map: MapComponent, data: any) {
    const styles = [];
    map.SLMap.SetBaseMap('streets');




  }
  static SetLightBaseMap(map: MapComponent, data: any) {
    map.SLMap.SetBaseMap('light');


  }
  static SetDarkBaseMap(map: MapComponent, data: any) {
    map.SLMap.SetBaseMap('dark');


  }
  static SetOutdoorBaseMap(map: MapComponent, data: any) {
    map.SLMap.SetBaseMap('outdoors');

  }
  static SetsatelliteBaseMap(map: MapComponent, data: any) {
    map.SLMap.SetBaseMap('satstreets');

  }
  static ToggleHillshade(map: MapComponent, data: any) {
    map.SLMap.ToggleHillShade();
  }
  static ToggleContour(map: MapComponent, data: any) {
    map.SLMap.ToggleContour();
  }
  static ToggleBuildings(map: MapComponent, data: any) {
    map.SLMap.ToggleBuildings();
  }
  static ToggleTerrain(map: MapComponent, data: any) {
    if (data?.isOn === false) {
      console.log('terrain off');
    }
    map.SLMap.ToggleTerrain(undefined, data?.isOn === undefined ? undefined : data.isOn);
  }

  static FullScreen(map: MapComponent, data?: any) {
    let doc: any = document.documentElement;
    document.getElementsByTagName('body').item(0).classList.toggle('full-screen', true);
    document.getElementsByTagName('body').item(0).classList.toggle('not-full-screen', false);
    const button = map.SLMap.src.GetButton('exitFullScreen-toggle');

    if (doc.mozRequestFullScreen) {
      doc.mozRequestFullScreen();
    } else if (doc.requestFullscreen) {
      doc.requestFullscreen().catch((issue) => {
        console.log('Full screen request failure', issue);
      });
    } else if (doc.webkitRequestFullscreen) {
      doc.webkitRequestFullscreen();
    } else if (doc.msRequestFullscreen) {
      doc.msRequestFullscreen();
    } else {
      doc = document;
      if (doc.requestFullscreen) {
        doc.requestFullscreen({ navigationUI: 'hide' });
      } else if (doc.mozRequestFullScreen) {
        doc.mozRequestFullScreen();
      } else if (doc.webkitRequestFullscreen) {
        doc.webkitRequestFullscreen();
      } else if (doc.msRequestFullscreen) {
        doc.msRequestFullscreen();
      }
    }
    if (map.SLMap.src.buttonGroups) {
      window.requestAnimationFrame(() => {
        (map.SLMap.src.buttonGroups as ButtonGroupService).GetButtonSet('viewerOptions').HandleButtonSelect(button);
      });
    }
    /* const buttons: Array<HTMLButtonElement> = map.SLMap.src.GetActionButtons('Screen');
    for (const button of buttons) {
      if (button.title.toLowerCase() === 'full screen') {
        $(button).toggleClass('hidden', true);
      }
      if (button.title.toLowerCase() === 'exit full screen') {
        $(button).toggleClass('hidden', false);
      }
    }*/

  }
  static ExitFullScreen(map: MapComponent, data: any) {
    const doc: FullScreenElement = document as FullScreenElement;
    if (doc.requestFullscreen) {
      doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) {
      doc.msExitFullscreen();
    }
    document.getElementsByTagName('body').item(0).classList.toggle('full-screen', false);
    document.getElementsByTagName('body').item(0).classList.toggle('not-full-screen', true);
    const button = map.SLMap.src.GetButton('fullScreen-toggle');
    if (map.SLMap.src.buttonGroups) {
      window.requestAnimationFrame(() => {
        (map.SLMap.src.buttonGroups as ButtonGroupService).GetButtonSet('viewerOptions').HandleButtonSelect(button);
      });
    }
    /*const buttons: Array<HTMLButtonElement> = map.SLMap.src.GetActionButtons('Screen');
    for (const button of buttons) {
      if (button.title.toLowerCase() === 'full screen') {
        $(button).toggleClass('hidden', false);
      }
      if (button.title.toLowerCase() === 'exit full screen') {
        $(button).toggleClass('hidden', true);
      }
    }*/
  }
  static ToggleBars(map: MapComponent, data: any) {
    map.SLMap.src.hidingHeaderFooter = !map.SLMap.src.hidingHeaderFooter;
    map.SLMap.src.ToggleClass('hide-bars', map.SLMap.src.hidingHeaderFooter);

    setTimeout(() => { map.SLMap.component.UpdateSize(); }, 120);
  }
  static SetupButtons(map) {

    if (map.SLMap === undefined) {
      setTimeout(() => { DisplayAction.SetupButtons(map); }, 10);
      return;
    }
    const buttons: Array<HTMLButtonElement> = map.SLMap.src.GetActionButtons('Screen');
    for (const button of buttons) {
      if (button.title.toLowerCase() === 'full screen') {
        button.addEventListener('click', () => { DisplayAction.FullScreen(map); });
        break;
      }
    }

  }
  static UpdateDrawListeners(map: MapComponent, info: { drawpane: DrawPaneComponent, 'is_on': boolean }) {
    if (map?.PUCMan) {
      map.PUCMan.HandleDrawStateChange(info);
    }
  }

  static UpdatePanels() {
    const map = MapService.Get(0);
    if (map?.src?.panelSet) {
      map.src.panelSet.UpdatePanels();
    }
  }
  static SetLayerOpacity(map: MapComponent, data: any | OpacityTogglePayload) {
    const layers = getList<string>(data.layers);
    const opacity = getNumber(data.opacity, 1);

    for (const layerId of layers) {
      const layer = map.SLMap.GetLayerById(layerId);
      if (layer) {
        layer.SetOpacity(opacity, map.SLMap);
      }
    }
  }

  static ToggleLayerVisibility(map: MapComponent, data: any | ToggleVisibilityPayload) {
    if (data.visibility_map && typeof data.visibility_map === 'object') {
      for (const [layerId, isOn] of Object.entries(data.visibility_map)) {
        const layer = map.SLMap.GetPLayerById(layerId);
        if (layer) {
          layer.SetLayerOn(!!isOn, map.SLMap);

        }
      }
      return;
    }

  }
  static DoOnIdle(map:MapComponent,handler:AnyHandler) {
    const mapUI = map.SLMap.ui;
    if (mapUI.loaded()) {
        if (!mapUI.isMoving()) {
          handler();
        } else {
          mapUI.once('idle', handler);
        }
      } else {
        mapUI.once('load', () => {
          // After load, wait for idle
          if (!mapUI.isMoving()) {
            handler();
          } else {
            mapUI.once('idle', handler);
          }
        });
      }

  }

}
